import { LandingPageCustomization } from './LandingPageCustomization'
import { PrintableApi } from '@/cowboy/printable/PrintableApi'

export default {
  name: 'LandingPageCustomizationContainer',
  props: {
    uri: {
      type: String,
      required: true
    }
  },
  data: () => ({
    landingPageCustomization: null,
    isLoading: true
  }),
  computed: {
    errorCaught () {
      return !this.isLoading && !this.landingPageCustomization
    }
  },
  async mounted () {
    await this.initializeLandingPageCustomization()
  },
  methods: {
    async initializeLandingPageCustomization () {
      this.isLoading = true
      try {
        this.landingPageCustomization = await this.getLandingPageCustomizationByUri(
          this.uri
        )
      } catch (error) {
        console.error(
          `Error while trying to load the landing page customization on load for URI = ${this.uri} : `,
          error
        )
      } finally {
        this.isLoading = false
      }
    },
    async getLandingPageCustomizationByUri (uri) {
      const landingPageCustomizationRetrieved = (await PrintableApi.landingPage(uri)).toJSON()
      return new LandingPageCustomization(landingPageCustomizationRetrieved)
    }
  },
  render () {
    return this.$scopedSlots.default({
      landingPageCustomization: this.landingPageCustomization,
      isLoading: this.isLoading,
      errorCaught: this.errorCaught
    })
  }
}
